import { useState } from "react";
import useCartStore from "../../utils/cartStore";

const COLORS = ["Rouge", "Mauve", "Rose", "Bleu", "Vert"];

const RosesProduct = () => {
  const addToCart = useCartStore((state) => state.addToCart);

  const [quantity, setQuantity] = useState(1);
  const [color, setColor] = useState("Rouge");

  const price = quantity * 3;

  const handleAddToCart = () => {
    addToCart(
      {
        id: `rose-${color}-${quantity}`,
        name: `Roses ${color}`,
        price: 3,
        image: "/images/evenement_produits/fleur_individuelle.jpg",
        category: "Événements",
        description: `${quantity} roses ${color}`
      },
      quantity
    );
  };

  return (
    <div className="bg-white rounded-2xl shadow p-6">

      <img
        src="/images/evenement_produits/fleur_individuelle.jpg"
        alt="Roses"
        className="w-full h-56 object-contain rounded-xl mb-4"
      />

      <h2 className="text-xl font-semibold mb-2">
        Roses individuelles
      </h2>

      <p className="text-gray-500 mb-4">
        3 € / pièce
      </p>

      {/* COULEUR */}
      <div className="mb-4">
        <label className="block mb-2 font-medium">
          Couleur :
        </label>
        <select
          value={color}
          onChange={(e) => setColor(e.target.value)}
          className="w-full border rounded-lg px-3 py-2"
        >
          {COLORS.map((c) => (
            <option key={c}>{c}</option>
          ))}
        </select>
      </div>

      {/* QUANTITÉ */}
      <div className="flex items-center gap-4 mb-4">
        <button
          onClick={() => setQuantity(Math.max(1, quantity - 1))}
          className="w-8 h-8 border rounded"
        >
          −
        </button>

        <span>{quantity}</span>

        <button
          onClick={() => setQuantity(quantity + 1)}
          className="w-8 h-8 border rounded"
        >
          +
        </button>
      </div>

      <p className="font-bold mb-4">
        Total : {price} €
      </p>

      <button
        onClick={handleAddToCart}
        className="btn-primary w-full"
      >
        Ajouter au panier
      </button>
    </div>
  );
};

export default RosesProduct;